module.exports = __webpack_public_path__ + "img/mgh-kyobashi@2x.7cdad10c.jpg";